export default "__VITE_ASSET__c25b2b23__"